export default function scrollToElement({ container, elementPosition }) {
  return container.scroll({
    top: elementPosition,
    left: 0,
    behavior: "smooth",
  });
}
